import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { MY_LISTINGS_KEY, MY_PACKAGE_KEY } from '@steelbuy/data-access';
import {
    ListingSellerDraftCollectionDataProvider,
    ListingSellerDraftEntityDataProvider,
} from '@steelbuy/data-provider';
import { useCreateListingContext } from '../../components/create-listing/CreateListingContext';

export const CreateListingView = () => {
    const location = useLocation();
    const { createListingData } = location.state || {};
    const createListingContext = useCreateListingContext();
    const [isInitialDataSet, setIsInitialDataSet] = useState(false);
    const queryClient = useQueryClient();

    useEffect(() => {
        if (createListingData) {
            createListingContext.copyFromListing(createListingData);
            setIsInitialDataSet(true);
        }
        queryClient.removeQueries({ queryKey: [MY_LISTINGS_KEY] });
        queryClient.removeQueries({ queryKey: [MY_PACKAGE_KEY] });
    }, []);

    if (createListingData && !isInitialDataSet) {
        return null;
    }

    return (
        <ListingSellerDraftCollectionDataProvider lazyLoad>
            <ListingSellerDraftEntityDataProvider entityId="" lazyLoad>
                <Outlet />
            </ListingSellerDraftEntityDataProvider>
        </ListingSellerDraftCollectionDataProvider>
    );
};
